import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '../../../../core/animations';
import { RecommendationService } from '../../../../core/services/recommendation.service';
import { FuseNavigationService } from '../../../../core/components/navigation/navigation.service';

@Component({
  selector: 'recommendation-event',
  templateUrl: './recommendation-events.component.html',
  styleUrls: ['./recommendation-events.component.scss'],
  standalone: false,
  animations: fuseAnimations
})

export class RecommendationEventComponent implements OnInit {
  currentIndex = 0;
  events: any = [];
  loading = true;
  constructor(private recommendationService: RecommendationService, private navigationService: FuseNavigationService) {
  }

  ngOnInit() {
    this.getRecommendationEvents();
    const eventNavItem = this.navigationService.getNavigationItem('recommendation.recommendation-event');
    if (eventNavItem?.badge)  {
      const recommendationNavItem = this.navigationService.getNavigationItem('recommendation');
      if (recommendationNavItem.badge) recommendationNavItem.badge = recommendationNavItem.badge - eventNavItem.badge;
      eventNavItem.badge = 0;
    }
  }

  getRecommendationEvents(): void {
    this.recommendationService.recommendations('event').subscribe((events: any) => {
      this.recommendationService.favoriteRecommendation().subscribe((favorEvent: any) => {
        if (events){
          for (let i = 0; i < favorEvent.length; i++) {
            let index = events.findIndex(event => +event.id === +favorEvent[i].recommendationId);
            if (index > -1) {
              events[index].isFavorite = true;
              events[index].favId = favorEvent[i].id;
            }
          }
          this.events = events;
        }
        this.loading = false;
      });
    })
  }

  scrollCarousel(direction) {
    const carousel = document.getElementById('carousel');
    const cards = carousel.children;
    const total = cards.length;

    this.currentIndex += direction;

    if (this.currentIndex < 0) this.currentIndex = 0;
    if (this.currentIndex >= total) this.currentIndex = total - 1;

    const offset = -this.currentIndex * 100;
    carousel.style.transform = `translateX(${offset}%)`;
  }

  deleteEvent(index: number) {
    this.events.splice(index, 1);
    if (this.currentIndex > 0) this.scrollCarousel(-1);
  }
}
